// Teklif servisleri - API çağrıları
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Axios interceptor - Token ekleme
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Tüm teklifleri getir
export const getOffers = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    
    // Filtreleri ekle
    if (filters.search) params.append('search', filters.search);
    if (filters.status) params.append('status', filters.status);
    if (filters.customer_id) params.append('customer_id', filters.customer_id);
    if (filters.project_id) params.append('project_id', filters.project_id);
    if (filters.customer) params.append('customer', filters.customer);
    if (filters.project) params.append('project', filters.project);
    if (filters.created_by) params.append('created_by', filters.created_by);
    if (filters.date) params.append('date', filters.date);
    if (filters.page) params.append('page', filters.page);
    if (filters.limit) params.append('limit', filters.limit);

    const response = await axios.get(`${API_URL}/offers?${params}`);
    return response.data;
  } catch (error) {
    console.error('Teklifler getirilirken hata:', error);
    throw error;
  }
};

// Teklif oluşturan kullanıcıların tekil listesi (filtrelerle)
export const getOfferCreators = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    if (filters.search) params.append('search', filters.search);
    if (filters.status) params.append('status', filters.status);
    if (filters.customer_id) params.append('customer_id', filters.customer_id);
    if (filters.project_id) params.append('project_id', filters.project_id);
    if (filters.customer) params.append('customer', filters.customer);
    if (filters.project) params.append('project', filters.project);
    if (filters.date) params.append('date', filters.date);
    const response = await axios.get(`${API_URL}/offers/creators?${params}`);
    return response.data; // { creators: [{id, user_fullname}...] }
  } catch (error) {
    console.error('Teklif oluşturanlar alınırken hata:', error);
    throw error;
  }
};

// Belirli bir teklifi getir
export const getOffer = async (offerId) => {
  try {
    const response = await axios.get(`${API_URL}/offers/${offerId}`);
    return response.data;
  } catch (error) {
    console.error('Teklif getirilirken hata:', error);
    throw error;
  }
};

// Yeni teklif oluştur
export const createOffer = async (offerData) => {
  try {
    const response = await axios.post(`${API_URL}/offers`, offerData);
    return response.data;
  } catch (error) {
    console.error('Teklif oluşturulurken hata:', error);
    throw error;
  }
};

// Teklifi güncelle
export const updateOffer = async (offerId, offerData) => {
  try {
    const response = await axios.put(`${API_URL}/offers/${offerId}`, offerData);
    return response.data;
  } catch (error) {
    console.error('Teklif güncellenirken hata:', error);
    throw error;
  }
};

// Teklifi sil
export const deleteOffer = async (offerId) => {
  try {
    const response = await axios.delete(`${API_URL}/offers/${offerId}`);
    return response.data;
  } catch (error) {
    console.error('Teklif silinirken hata:', error);
    throw error;
  }
};

// Teklif durumunu güncelle
export const updateOfferStatus = async (offerId, status) => {
  try {
    const response = await axios.patch(`${API_URL}/offers/${offerId}/status`, { status });
    return response.data;
  } catch (error) {
    console.error('Teklif durumu güncellenirken hata:', error);
    throw error;
  }
};

// Teklif istatistiklerini getir
export const getOfferStats = async () => {
  try {
    const response = await axios.get(`${API_URL}/offers/stats`);
    return response.data;
  } catch (error) {
    console.error('Teklif istatistikleri getirilirken hata:', error);
    throw error;
  }
};

// Müşteriye ait teklifleri getir
export const getOffersByCustomer = async (customerId) => {
  try {
    const response = await axios.get(`${API_URL}/offers/customer/${customerId}`);
    return response.data;
  } catch (error) {
    console.error('Müşteri teklifleri getirilirken hata:', error);
    throw error;
  }
};

// Projeye ait teklifleri getir
export const getOffersByProject = async (projectId) => {
  try {
    const response = await axios.get(`${API_URL}/offers/project/${projectId}`);
    return response.data;
  } catch (error) {
    console.error('Proje teklifleri getirilirken hata:', error);
    throw error;
  }
};

// Teklif dosyasını indir
export const downloadOfferFile = async (offerId) => {
  try {
    const response = await axios.get(`${API_URL}/offers/${offerId}/download`, {
      responseType: 'blob'
    });
    return response;
  } catch (error) {
    console.error('Teklif dosyası indirilirken hata:', error);
    throw error;
  }
};

// Teklif dosyasını sil
export const deleteOfferFile = async (offerId) => {
  try {
    const response = await axios.delete(`${API_URL}/offers/${offerId}/file`);
    return response.data;
  } catch (error) {
    console.error('Teklif dosyası silinirken hata:', error);
    throw error;
  }
};
